/* 布局 */
//前台
import Layout from "@views/layout";

const postRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "post",
            name: "POST",
            meta: {
                title: "帖子管理",
                sort: 1,
            },
            component: () => import("@views/business/post/index.vue"),
            redirect: {
                name: "POST_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "POST_LIST",
                    meta: {
                        title: "帖子管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/post/list.vue"),
                },
                                {
                    path: "add",
                    name: "POST_ADD",
                    meta: {
                        title: "新增帖子表",
                        parentPath: '/business/post/list',
                        operate: true,
                    },
                    component: () => import("@views/business/post/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "POST_EDIT",
                    meta: {
                        title: "编辑帖子表",
                        parentPath: '/business/post/list',
                        operate: true,
                    },
                    component: () => import("@views/business/post/form.vue"),
                },
                                        ],
    },


        ],
};

export default postRouter;
